// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3svo7","col":"styles_col__2rQ-7"};